<template>
  <v-row :dir="$i18n.locale === 'he' ? 'rtl' : 'ltr'">
    <v-col cols="12">
      <v-card class="meta-card" flat>
        <div class="meta-grid">
          <!-- Common fields extracted to component -->
          <AlertMetaItem :label="$t('id') + ':'" :value="extractNumericId(alert.identifier)" />
          <AlertMetaItem :label="$t('sender') + ':'" :value="alert.sender || '-'" />
          <AlertMetaItem
            :label="$t('received') + ':'"
            :value="receivedDisplay"
          />
          <AlertMetaItem :label="$t('type') + ':'" :value="alert.msgType || '-'" />

          <!-- status -->
          <div class="meta-label">{{ $t("status") }}:</div>
          <div class="meta-value">
            <v-chip :color="getStatusColor(alert.status)" size="small" variant="flat">
              {{ $t(alert.status ? alert.status.toLowerCase() : "unknown") }}
            </v-chip>
          </div>

          <!-- Remaining common fields -->
          <AlertMetaItem :label="$t('headline') + ':'" :value="info?.headline || '-'" />
          <AlertMetaItem :label="$t('description') + ':'" :value="info?.description || '-'" />
          <AlertMetaItem :label="$t('messageSizeHeader') + ':'" :value="formatBytes(alert.messageSize || 0)" />
          <AlertMetaItem :label="$t('layers') + ':'" :value="layersDisplay" />

          <!-- severity -->
          <div class="meta-label">{{ $t("severityHeader") }}:</div>
          <div class="meta-value">
            <v-chip :color="getSeverityColor(alert.severity)" size="small" variant="flat">
              {{ $t(alert.severity ? alert.severity.toLowerCase() : "unknown") }}
            </v-chip>
          </div>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { getSeverityColor } from "../../config/severityColors.js";
import { getStatusColor } from "../../config/statusColors.js";
import AlertMetaItem from "./AlertMetaItem.vue";

export default {
  name: "AlertMetaFlexible",
  props: {
    alert: { type: Object, required: true },
  },
  computed: {
    info() {
      return Array.isArray(this.alert.info)
        ? this.alert.info[0]
        : this.alert.info || {};
    },
    receivedDisplay() {
      return this.alert.sent
        ? new Date(this.alert.sent).toLocaleString(
            this.$i18n.locale === "he" ? "he-IL" : "en-US"
          )
        : "-";
    },
    layersDisplay() {
      return this.alert.layers && this.alert.layers.length
        ? this.alert.layers.join(", ")
        : "-";
    },
  },
  methods: {
    extractNumericId(id) {
      if (!id) return "0";
      const numericPart = id.toString().replace(/\D/g, "");
      return numericPart || "0";
    },
    formatBytes(bytes) {
      if (bytes === 0) return "0 B";
      const k = 1024;
      const sizes = ["B", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + " " + sizes[i];
    },
    getSeverityColor,
    getStatusColor,
  },
  components: { AlertMetaItem },
};
</script>

<style scoped>
.meta-card {
  background: var(--v-theme-surface);
  border-radius: 18px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  padding: 24px;
  border: 1px solid var(--v-theme-outline-variant, #e0e0e0);

  /* keep the card from being stretched by long content */
  width: 100%;
  min-width: 0;
  overflow: hidden;
}


/* Label never grows */
.meta-label {
  color: var(--v-theme-secondary);
  font-weight: 500;
  font-size: 0.98rem;
  white-space: nowrap;
}

.meta-grid {
  display: grid;
  grid-template-columns: max-content minmax(0, 1fr);
  gap: 12px;
  min-width: 0; /* grid itself can shrink */
  flex: 1 1 auto;
  overflow: auto;
}

.meta-value {
  display: flex;
  align-items: center;
  min-width: 0; /* let this shrink inside grid */
}

.value-clip {
  flex: 1 1 auto;
  min-width: 0; /* let this shrink inside flex */
}

.ellipsis {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* Let tooltip content wrap so it does not stretch layout */
.tooltip-wrap {
  display: inline-block;
  max-width: min(70vw, 560px);
  white-space: normal;
  word-break: break-word;
}

@media (max-width: 768px) {
  .meta-card { padding: 16px; }
  .meta-label { font-size: 0.9rem; }
}
</style>
